import { GET } from "@/api/client";
import { TResponse } from "@/api/types";
import { useInfiniteQuery } from "@tanstack/react-query";
import { AcceptanceStatus, InsightTableData } from "../../types";

interface useGetInsightListParams {
  page?: number;
  pageSize?: number;
  filterStatus?: AcceptanceStatus;
  searchTitle?: string;
  sortBy?: string;
  sortDir?: "asc" | "desc";
}

export const useGetInsightList = (
  params: Omit<useGetInsightListParams, "page">
) => {
  return useInfiniteQuery({
    queryKey: ["/transfer/requests", params],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await GET<TResponse<InsightTableData[]>>(
        "/transfer/requests",
        {
          ...params,
          page: pageParam,
          hospitalCode: "A1300002",
        }
      );
      return response;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const currentPage = allPages.length;
      const hasMore = (lastPage.result.data?.length ?? 0) > 0;
      return hasMore ? currentPage + 1 : undefined;
    },
  });
};
